<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d7e32410"><span><a href="#/Text/Morg_9781550924589_epub_c5_r1#d7e2178" id="d14e212">acknowledgments</a></span></p>
<p class="tx1" id="d7e32910"><span>A lifetime of cooking and gardening with friends and family could make this list as long as the book itself, but there are some people I particularly want to thank. Carolyn Dale and Tim Pilgrim, for kiwis, rhubarb, and great meals; Mary Jean Wiegert and Bruce Underwood for rutabagas and a memorable evening in their fabulous kitchen; Robert (Goldtooth) Ray, for taste testing both the successes and the stranger experiments; Mark Musick, Bruce Naftaly, Jon Kemnitzer, Deb Anderson-Frey, Marilyn Lewis, Gale Lawrence, Bill Bowes, and Kristen Barber for recipes and encouragement; Curt Madison, for 40+ years of friendship and that moose roast; Bruce Brown, for Sumas days and for reminding me about my garden journals; my friend and agent Anne Depue; and my family—Deshanna Brown, Laurel, Ronny and Hailey Tull, and Andrew Tull—for loving me.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Morg_9781550924589_epub_c6_r1.vue?7b5b00ce